import { Route, Routes } from '@angular/router';
import { Error403Component } from './pages/error-403/error-403.component';

export const errorRoutes: Route[] = [
    {
        path: 'error-403',
        component: Error403Component,
    },
] as Routes;
